import { formatCount } from './formatCount';

/**
 * The count at the far right of a list card's toolbar (spec 226 FR-006), and
 * the sentence a screen reader hears once typing pauses (FR-007): "12 members"
 * when nothing narrows the list, "3 of 12 members" when something does. The
 * noun follows the total, so "1 of 12 members" and "1 member" both read right.
 */
export function listCardCount(
  shown: number,
  total: number,
  noun: readonly [string, string],
): string {
  const word = total === 1 ? noun[0] : noun[1];
  if (shown === total) return `${formatCount(total)} ${word}`;
  return `${formatCount(shown)} of ${formatCount(total)} ${word}`;
}
